import React, { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Container, Grid, Paper, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(4),
    },
    card: {
        padding: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'center',
        height: '100%',
    },
    button: {
        marginTop: theme.spacing(2),
    },
}));

interface IRouteParams {
    id: string;
}

const ProjectSettings: FC = () => {
    const classes = useStyles();
    const history = useHistory();
    const { id } = useParams<IRouteParams>();

    const handleNavigate = (path: string) => () => {
        history.push(path);
    };

    return (
        <Container className={classes.root} maxWidth="md">
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Typography variant="h4" gutterBottom>
                        Project Settings
                    </Typography>
                    <Typography variant="subtitle1" color="textSecondary">
                        Choose what you'd like to manage for this project.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper className={classes.card} elevation={2}>
                        <Typography variant="h6">Project Users</Typography>
                        <Typography variant="body2" color="textSecondary">
                            Manage project members and their access levels.
                        </Typography>
                        <Button
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            onClick={handleNavigate(`/admin/${id}/users`)}
                        >
                            Manage Users
                        </Button>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper className={classes.card} elevation={2}>
                        <Typography variant="h6">Assessment Templates</Typography>
                        <Typography variant="body2" color="textSecondary">
                            Configure template groups and details for assessments.
                        </Typography>
                        <Button
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            onClick={handleNavigate(`/admin/${id}/templates`)}
                        >
                            Manage Templates
                        </Button>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
};

export default ProjectSettings;
